<template>
    <v-card class="header-card" color="white" rounded="0">
        <!--
      MOBILE
    -->
        <!-- Drawer -->
        <v-navigation-drawer
            class="nav__side"
            width="90%"
            v-model="drawer"
            app
            temporary
            color="white"
        >
            <div class="d-flex">
                <v-app-bar-nav-icon class="align-self-center ml-2" @click.stop="drawer = !drawer" />
                <!-- Logo -->
                <v-list-item>
                    <v-list-item-content>
                        <router-link to="/">
                            <v-img
                                class="ma-0 pa-0"
                                src="@/assets/images/logo-tcs.webp"
                                width="60"
                                min-width="40"
                                content
                            />
                        </router-link>
                    </v-list-item-content>
                </v-list-item>
            </div>

            <!-- Si loggeado -->
            <template v-if="loggedIn">
                <v-divider />

                <v-list-item>
                    <v-list-item-avatar size="50">
                        <v-img :src="avatarPath" content />
                    </v-list-item-avatar>
                </v-list-item>
                <v-list-item v-if="loggedIn">
                    <span>
                        {{
                            this.getUser && this.getUser.firstName && this.getUser.lastName
                                ? `${getUser.firstName} ${getUser.lastName}`
                                : getUser.email
                        }}
                    </span>
                </v-list-item>
                <v-divider v-if="loggedIn"></v-divider>

                <v-list nav dense v-if="loggedIn && getItems.length !== 0">
                    <v-list-item
                        active-class="side-active"
                        class="side-txt"
                        v-for="item in getItems"
                        :key="item.title"
                        :to="item.to"
                    >
                        <v-list-item-icon>
                            <v-icon class="side-txt">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <Notifications type="side" />
                </v-list>
            </template>

            <v-divider />

            <!-- Side nav items -->
            <v-list-item
                class="nav__side-link"
                v-for="item in navItems"
                :key="item.label"
                :to="item.to"
                link
                dense
            >
                <v-list-item-content>
                    <v-list-item-title class="color-txt-primary">
                        {{ item.label }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <template v-if="getType !== 'candidate'">
                <v-divider />

                <v-list-item class="nav__side-link" to="/soy-organizacion" link dense>
                    <v-list-item-content>
                        <v-list-item-title class="color-txt-primary">
                            SOY ORGANIZACIÓN
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="nav__side-link" to="/pricing" link dense>
                    <v-list-item-content>
                        <v-list-item-title class="color-txt-primary">
                            PLANES Y PRECIOS
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>

            <v-divider />

            <!-- Inicio sesión / Registro -->
            <template v-if="!loggedIn">
                <v-list-item active-class="no-background" color="#3BADFF" to="/login">
                    <span class="nav-login__link nav-login__link--accent">INICIA SESIÓN</span>
                </v-list-item>
                <v-list-item>
                    <v-btn
                        :to="{ path: '/register/organization' }"
                        color="#3BADFF"
                        dark
                        elevation="0"
                    >
                        PUBLICA TU OFERTA
                    </v-btn>
                </v-list-item>
            </template>
            <v-list-item v-else to="/logout">
                <v-list-item-icon>
                    <v-icon class="logout">mdi-login-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    <span class="logout">
                        SALIR
                    </span>
                </v-list-item-title>
            </v-list-item>
        </v-navigation-drawer>

        <!-- Mobile Navbar -->
        <v-app-bar
            v-if="getBreakPoint === 'sm' || getBreakPoint === 'xs'"
            class="header-card__toolbar d-md-none pa-sm-0 ma-sm-0"
            color="white"
            height="60"
            rounded="0"
            fixed
            elevate-on-scroll
            hide-on-scroll
        >
            <!-- Burger -->
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

            <!-- Logo -->
            <router-link to="/">
                <v-img
                    class=""
                    src="@/assets/images/logo-tcs.webp"
                    content
                    width="60"
                    min-width="40"
                />
            </router-link>

            <v-spacer></v-spacer>

            <!-- Sin sesión iniciada -->
            <span v-if="!loggedIn" class="nav-registro px-1">
                <!-- Log in -->
                <v-btn
                    class="nav-registro__btn px-1 mx-1 orange--text"
                    to="/login"
                    color="#3BADFF"
                    small
                    text
                >
                    INICIA SESIÓN
                </v-btn>

                <!-- Sign up -->
                <v-menu offset-y open-on-hover>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="nav-registro__btn ma-0"
                            color="#3dadff"
                            elevation="0"
                            outlined
                            small
                            v-on="on"
                        >
                            REGÍSTRATE
                        </v-btn>
                    </template>
                    <v-card>
                        <v-list>
                            <v-btn
                                text
                                to="/register/candidate"
                                class="nav-registro__link text-left pa-3 d-block"
                            >
                                PERSONAS
                            </v-btn>
                            <v-btn
                                text
                                to="/register/organization"
                                class="nav-registro__link text-left pa-3 d-block"
                            >
                                ORGANIZACIONES
                            </v-btn>
                        </v-list>
                    </v-card>
                </v-menu>
            </span>

            <!-- Con sesión iniciada -->
            <v-col v-else class="color-txt-primary d-flex align-center menu-login">
                <v-menu :close-on-content-click="false" open-on-hover bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn small text v-on="on">
                            {{ userName }}
                        </v-btn>
                    </template>
                    <v-list dense class="pl-0">
                        <v-list-item @click="profilePath">
                            <v-list-item-content>
                                <v-list-item-title>Editar mi perfil</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="logout">
                            <v-list-item-content>
                                <v-list-item-title>Cerrar sesión</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn icon>
                    <router-link :to="homePath">
                        <v-avatar>
                            <v-img :src="avatarPath" />
                        </v-avatar>
                    </router-link>
                </v-btn>
            </v-col>
        </v-app-bar>

        <!-- Desktop Navbar -->
        <v-app-bar
            v-else
            class="header-card__toolbar px-auto"
            height="80"
            rounded="0"
            color="white"
            elevate-on-scroll
            hide-on-scroll
            fixed
            app
        >
            <v-tabs class="text-menu-desk mx-2" color="#3BADFF">
                <v-tabs-slider class="header-card__slider" color="#3c52a0" v-show="showSlider" />

                <!-- Logo -->
                <v-tab to="/" exact light>
                    <v-img src="@/assets/images/logo-tcs.webp" content width="75" min-width="50" />
                </v-tab>

                <v-hover
                    v-if="isOrganizationRoute && getType !== 'candidate'"
                    v-slot="{ hover }"
                    class="d-none d-md-flex align-self-center"
                >
                    <v-btn
                        class="nav__publish mx-2 px-2"
                        :to="{ path: '/register/organization' }"
                        :elevation="hover ? 5 : 0"
                        color="#3BADFF"
                        dark
                    >
                        PUBLICA TU OFERTA
                    </v-btn>
                </v-hover>

                <!-- Nav items -->
                <v-tab
                    v-else
                    v-for="item in navItems"
                    :key="item.label"
                    :to="item.to"
                    :href="item.href"
                    :target="item.href ? '_blank' : ''"
                    :class="item.class"
                    color="yellow"
                >
                    {{ item.label }}
                </v-tab>
            </v-tabs>

            <v-spacer></v-spacer>

            <!-- Sin sesión iniciada -->
            <v-tabs class="d-flex justify-end" color="#3BADFF">
                <v-tabs-slider class="header-card__slider" color="#3c52a0" v-show="showSlider" />
                <v-tab
                    v-if="!loggedIn || getType !== 'candidate'"
                    class="nav__item"
                    to="/soy-organizacion"
                >
                    SOY ORGANIZACIÓN
                </v-tab>
                <v-tab v-if="isOrganizationRoute" class="nav__item" to="/pricing">
                    PLANES Y PRECIOS
                </v-tab>
                <v-hover
                    v-if="!isOrganizationRoute && (!loggedIn || getType !== 'candidate')"
                    v-slot="{ hover }"
                    class="d-none d-md-flex align-self-center"
                >
                    <v-btn
                        class="mr-4 px-3"
                        :to="{ path: '/register/organization' }"
                        :elevation="hover ? 5 : 0"
                        color="#3BADFF"
                        dark
                    >
                        PUBLICA TU OFERTA
                    </v-btn>
                </v-hover>

                <div
                    v-if="!loggedIn || getType !== 'candidate'"
                    class="nav__divider align-self-center"
                ></div>

                <v-tab v-if="!loggedIn" class="nav__item orange--text" to="/login">
                    INICIA SESIÓN
                </v-tab>
            </v-tabs>

            <!-- Con sesión iniciada -->
            <v-col v-if="loggedIn" class="d-flex flex-row align-center ma-0 pa-0">
                <v-menu :close-on-content-click="false" open-on-hover bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn class="text-btn" text v-on="on">{{ userName }}</v-btn>
                    </template>
                    <v-list dense class="pl-0">
                        <v-list-item @click="profilePath">
                            <v-list-item-content>
                                <v-list-item-title>Editar mi perfil</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="logout">
                            <v-list-item-content>
                                <v-list-item-title>Cerrar sesión</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn icon class="mr-2" :to="homePath">
                    <v-avatar>
                        <v-img :src="avatarPath" />
                    </v-avatar>
                </v-btn>

                <Notifications />
            </v-col>
        </v-app-bar>
    </v-card>
</template>

<script>
import { userComputed } from "@/store/helpers.js";
import { currentImg } from "@/libs/mixins";
import Notifications from "@/components/Notifications";

export default {
    name: "AppNav",

    components: { Notifications },

    mixins: [currentImg],

    data() {
        return {
            drawer: false
        };
    },

    computed: {
        ...userComputed,
        showSlider() {
            return this.navItems.some(item => this.$route.path === item.to);
        },
        getBreakPoint() {
            return this.$vuetify.breakpoint.name;
        },
        userName() {
            if (this.getUser && this.getUser.firstName && this.getUser.lastName) {
                return this.getBreakPoint === "xs"
                    ? `${this.getUser.firstName}`
                    : `${this.getUser.firstName} ${this.getUser.lastName}`;
            }
            return this.getUser.email;
        },
        homePath() {
            let userType = this.$store.getters["users/getType"];
            return "/" + userType + "/home";
        },
        navItems() {
            const items = [
                { to: "/#search", label: "OFERTAS" },
                { to: "/services", label: "SERVICIOS" },
                { href: "https://flycrew.com/talentoimpacta/l/talento-impacta", label: "TALENTO IMPACTA", target: "_blank" },
                { to: "/organizations", label: "PARTNERS" },
            ];
            return items;
        },
        getItems() {
            const items = [];
            if (
                this.getUser &&
                this.getUser.type == "organization" &&
                this.getUser.role !== "sysadmin"
            ) {
                items.push({
                    title: "Publicaciones",
                    icon: "mdi-publish",
                    to: "/organization/home"
                });
                if (this.getUser.role == "admin") {
                    items.push({
                        title: "Usuarios",
                        icon: "mdi-account-circle",
                        to: "/organization/users"
                    });
                }
                items.push({
                    title: "Mi Pagina",
                    icon: "mdi-home",
                    to: { name: "OrganizationProfile", params: { noStepper: true } }
                });
            } else if (this.getUser && this.getUser.role === "sysadmin") {
                items.push({ title: "Publicaciones", icon: "mdi-publish", to: "/sysadmin/home" });
                items.push({
                    title: "Usuarios",
                    icon: "mdi-account-circle",
                    to: "/sysadmin/admin/users"
                });
                items.push({
                    title: "Organizaciones",
                    icon: "mdi-home",
                    to: "/sysadmin/organizations"
                });
            } else {
                items.push({
                    title: "MIS PUBLICACIONES",
                    icon: "mdi-view-dashboard",
                    to: "/candidate/home"
                });
                items.push({
                    title: "MI PERFIL",
                    icon: "mdi-account-circle",
                    to: { name: "CandidateProfile", params: { noStepper: true } }
                });
            }
            return items;
        },
        getBtns() {
            const btns = [];
            if (
                this.getUser &&
                this.getUser.type == "organization" &&
                this.getUser.role !== "sysadmin"
            ) {
                btns.push({
                    title: "NUEVA PUBLICACIÓN",
                    href: { name: "OfferPost", params: { followFlow: true } }
                });
            } else if (this.getUser && this.getUser.role === "sysadmin") {
                btns.push({
                    title: "MODERACIÓN",
                    icon: "mdi-tune-vertical",
                    href: "/sysadmin/moderation"
                });
            }
            return btns;
        },
        isOrganizationRoute() {
            return this.$route.path === "/soy-organizacion" || this.$route.path === "/pricing";
        }
    },

    methods: {
        profilePath() {
            let userType = this.$store.getters["users/getType"];
            if (userType === "organization") {
                this.$router.push({
                    name: "OrganizationProfile",
                    params: { noStepper: true }
                });
            }
            if (userType === "candidate") {
                this.$router.push({
                    name: "CandidateProfile",
                    params: { noStepper: true }
                });
            }
        },
        logout() {
            //this.$store.dispatch("users/logout");
            this.$router.push({ name: "Logout" });
        }
    }
};
</script>
